export const HERO_CONSTANTS = {
  TAG: "AI Technology",
  DATE: "October 23, 2023",
  TITLE: "Create Stunning Presentations with AI Presentation Makers",
  DESCRIPTION:
    "Explore how AI presentation makers can help you create professional and engaging presentations effortlessly. Learn about the features and advantages of using AI tools for your presentation needs.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/3456789/pexels-photo-3456789.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "AI presentation makers are transforming the way we create presentations by using advanced algorithms to automate design and content creation. This guide explores the benefits and applications of AI technology in presentation making.",
  "From designing slides to generating content, AI presentation makers offer a range of features that can help you create professional and engaging presentations effortlessly. We'll delve into the different tools available and how to use them effectively.",
  "Whether you're a business professional or a student, AI presentation makers provide powerful solutions for creating stunning presentations. Let's explore the potential benefits and applications of AI technology in presentation making.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding AI Presentation Makers",
    content:
      "AI presentation makers use advanced algorithms to automate the design and content creation process. These tools can generate slides, suggest layouts, and even create content based on your input, making it easier to create professional presentations.",
  },
  {
    title: "2. Benefits of Using AI Presentation Makers",
    content:
      "AI presentation makers offer several benefits, including time savings, improved design quality, and ease of use. These tools can quickly generate professional-looking presentations, allowing you to focus on delivering your message.",
  },
  {
    title: "3. Applications in Presentation Making",
    content:
      "AI presentation makers can be used in a variety of presentation making projects, from business presentations to academic projects. These tools are ideal for creating engaging and visually appealing presentations that capture your audience's attention.",
  },
  {
    title: "4. Choosing the Right AI Presentation Maker",
    content:
      "When selecting an AI presentation maker, consider factors such as features, ease of use, and compatibility with your existing software. Look for tools that offer a range of design options and provide high-quality results.",
  },
  {
    title: "5. Tips for Using AI Presentation Makers",
    content:
      "To get the best results from AI presentation makers, start with a clear outline of your presentation and use the tools' features to enhance your slides. Experiment with different layouts and designs to create a visually appealing presentation.",
  },
  {
    title: "6. Maintenance and Updates",
    content:
      "Keep your AI presentation maker software up to date to ensure you have access to the latest features and improvements. Regularly check for updates and take advantage of new tools and enhancements as they become available.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/3456790/pexels-photo-3456790.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "Top AI Tools for Presentation Making in 2023",
    description:
      "Explore the latest AI tools for presentation making in 2023. Learn how to use these tools to create professional and engaging presentations.",
  },
  {
    image:
      "https://images.pexels.com/photos/3456791/pexels-photo-3456791.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How to Create Stunning Presentations with AI Technology",
    description:
      "Discover practical tips for creating stunning presentations with AI technology. Follow our step-by-step guide to achieve professional results.",
  },
  {
    image:
      "https://images.pexels.com/photos/3456792/pexels-photo-3456792.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Choosing the Right AI Tools for Your Presentation Needs",
    description:
      "Learn about the different AI tools available for presentation making. Understand the benefits and applications of each tool to make informed decisions.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Create Professional Presentations with AI Tools",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/3456793/pexels-photo-3456793.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Learn More",
  COPYRIGHT: " 2024 AI Presentation Trends. All rights reserved",
};
